import {Section, Stack} from '@primer/react-brand/esm'
import type {ComponentProps} from 'react'

import {ContentfulCards} from '@github-ui/swp-core/components/contentful/ContentfulCards'
import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'

import type {PricingCardsContent} from '../../content'

type Props = {
  content: PricingCardsContent
  paddingBlockEnd?: ComponentProps<typeof Section>['paddingBlockEnd']
}

export function CardsSection({content, paddingBlockEnd = 'none'}: Props) {
  return (
    <Section id={content.htmlId} variant="gridline" fullWidth paddingBlockEnd={paddingBlockEnd}>
      <Stack padding="none" gap={{narrow: 48, regular: 64}}>
        {content.intro && <ContentfulSectionIntro component={content.intro} />}

        <ContentfulCards cards={content.cards} variant="gridline" fullWidth ctaVariant="arrow" />
      </Stack>
    </Section>
  )
}
